import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import API from '@/lib/api';
import { Clock, MapPin, Users } from 'lucide-react';

export default function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/events').then(r => setEvents(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-20"><div className="w-8 h-8 border-2 border-[#E05A47] border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div className="fade-in space-y-8" data-testid="events-page">
      <div>
        <h1 className="text-3xl font-extrabold tracking-tight text-[#222] font-[Manrope]">Chef Events</h1>
        <p className="mt-2 text-[#717171]">Curated dining experiences in your building</p>
      </div>
      {events.length === 0 ? (
        <div className="text-center py-16 text-[#717171]">No upcoming events at the moment</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {events.map(ev => (
            <Link key={ev.id} to={`/events/${ev.id}`} className="bg-white rounded-2xl border border-[#EBEBEB] overflow-hidden card-hover" data-testid={`event-card-${ev.id}`}>
              <div className="relative">
                <img src={ev.image || 'https://images.unsplash.com/photo-1768508950719-4d76978fdf44'} alt={ev.title} className="w-full h-48 object-cover" />
                <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm rounded-full px-3 py-1 text-xs font-bold text-[#222]">${ev.price}/seat</div>
              </div>
              <div className="p-5">
                <div className="inline-block px-2.5 py-1 rounded-full bg-[#E05A47]/10 text-[#E05A47] text-xs font-semibold mb-2.5">{ev.theme}</div>
                <h3 className="font-bold text-lg text-[#222] font-[Manrope]">{ev.title}</h3>
                <p className="text-sm text-[#717171] mt-1 line-clamp-2">{ev.description}</p>
                <div className="flex flex-col gap-1.5 mt-3 text-xs text-[#717171]">
                  <span className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" strokeWidth={1.5} />{new Date(ev.date).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })} at {ev.time}</span>
                  <span className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" strokeWidth={1.5} />{ev.location}</span>
                  <span className="flex items-center gap-1.5"><Users className="w-3.5 h-3.5" strokeWidth={1.5} />{ev.capacity - (ev.seats_booked || 0)} of {ev.capacity} seats available</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
